


















































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import elasticlunr from 'elasticlunr';

import Input from '@/components/form/Input.vue';
import ArticleCategoryCard from '@/components/ArticleCategoryCard.vue';
import {TranslateResult} from 'vue-i18n';

@Component({
	components: {
		'v-input': Input,
		'v-article-category-card': ArticleCategoryCard
	}
})
export default class Search extends Vue {
	@Prop({default: true}) readonly searchInput: boolean;

	articlesData: any[];
	index: any = {};

	searchValue: string = '';
	searchItems: any[] = [];

	get locale(): string {
		return this.$store.state.locale;
	}

	get popularCategories(): TranslateResult {
		return this.$t('help.popularCategories');
	}

	@Watch('searchValue')
	onSearchChanged(newValue: string): void {
		this.searchItems = this.search(newValue);
	}

	created(): void {
		this.articlesData = this.$t('help.categories') as any;
	}

	mounted(): void {
		if (typeof window === 'undefined') {
			return;
		}
		this.index = elasticlunr();

		this.index.addField('category');
		this.index.addField('section');
		this.index.addField('headline');
		this.index.addField('title');
		this.index.addField('body');

		this.index.setRef('id');

		for (const category of this.articlesData) {
			for (const section of category.items) {
				const id = category.items.indexOf(section);

				this.index.addDoc({
					id: `${category.slug}@${id}`,
					category: category.slug,
					section: id,
					headline: category.headline,
					title: section.title,
					body: section.content.join(' ')
				});
			}
		}
	}

	search(value: string): any[] {
		return this.index.search(value)
			.map((item: any) => this.index.documentStore.docs[item.ref]);
	}
}
